import React from "react";
import { Template } from "../../data/templates";

interface TemplateCardProps {
  template: Template;
  onClick: () => void;
}

export function TemplateCard({ template, onClick }: TemplateCardProps) {
  const Icon = template.icon;

  return (
    <div className="bg-white/5 backdrop-blur-sm rounded-xl overflow-hidden">
      <div className="p-6">
        <div className="w-12 h-12 bg-volt-blue/20 rounded-lg flex items-center justify-center mb-4">
          <Icon className="w-6 h-6 text-volt-blue" />
        </div>
        <h3 className="text-lg font-medium text-white mb-2">
          {template.title}
        </h3>
        <p className="text-sm text-gray-400 mb-4">{template.description}</p>
        <button
          onClick={onClick}
          className="text-volt-blue hover:text-volt-green transition-colors text-sm"
        >
          View template →
        </button>
      </div>
    </div>
  );
}
